import { create } from 'zustand';

const initialState = {
  selectedPatient: null,
  cart: [],
  filters: {
    search: '',
    categoryIds: [],
    subCategoryIds: [],
    segmentIds: [],
  },
};

const toPositiveQuantity = (value) =>
  Math.max(1, Number.parseInt(value, 10) || 1);

export const useSuballocationStore = create((set) => ({
  ...initialState,
  setSelectedPatient: (selectedPatient) => set({ selectedPatient }),
  setFilters: (filters) =>
    set((state) => ({ filters: { ...state.filters, ...filters } })),
  addToCart: (product, quantity = 1) =>
    set((state) => {
      const lineId = String(product.id);
      const amount = toPositiveQuantity(quantity);
      const existing = state.cart.find((item) => item.lineId === lineId);
      if (existing) {
        return {
          cart: state.cart.map((item) =>
            item.lineId === lineId
              ? { ...item, quantity: item.quantity + amount }
              : item
          ),
        };
      }
      return {
        cart: [
          ...state.cart,
          {
            lineId,
            productId: product.id,
            sku: product.sku,
            name: product.name,
            image: product.images[0],
            quantity: amount,
          },
        ],
      };
    }),
  updateQuantity: (lineId, quantity) =>
    set((state) => {
      const amount = Number.parseInt(quantity, 10);
      if (!Number.isFinite(amount) || amount < 1)
        return { cart: state.cart.filter((item) => item.lineId !== lineId) };
      return {
        cart: state.cart.map((item) =>
          item.lineId === lineId ? { ...item, quantity: amount } : item
        ),
      };
    }),
  removeFromCart: (lineId) =>
    set((state) => ({
      cart: state.cart.filter((item) => item.lineId !== lineId),
    })),
  reset: () => set({ ...initialState }),
}));
